import { RefString, RefNumber, RefDate } from "@tblabs/truffle";
import { RawExpanse } from "./RawExpanse";


export class Expanse
{
    public Category = new RefString();
    public Description = new RefString();
    public Amount = new RefNumber();
    public When = new RefDate();

    constructor(raw: Partial<RawExpanse>)
    {
        this.Category.value = raw.Category || "";
        this.Description.value = raw.Description || "";
        this.Amount.value = raw.Amount || 0;
        this.When.value = new Date(raw.When || 0);
    }

    public ToRaw(): RawExpanse
    {
        return ({
            Category: this.Category.value,
            Description: this.Description.value,
            Amount: this.Amount.value,
            When: this.When.value
        });
    }
}
